import { useAccountData } from "./useAccountData";

export const USER_ENTITLEMENT_QUERY_KEY = "user-entitlement";

export function useUserEntitlementQueryKey() {
  const accountData = useAccountData();
  const user = accountData?.user;

  return [
    USER_ENTITLEMENT_QUERY_KEY,
    user?.id ?? 0,
    user?.gold === true ? "gold" : "non-gold",
    accountData?.subscription === true ? "subscribed" : "unsubscribed",
  ] as const;
}
